import React from "react";
import {IonButton} from '@ionic/react';


const WrapperIonButton = (
    {
        title,
        type = 'button',
        disabled = false,
        expand="block",
        Click = () => {},
    }
) => {
    return <IonButton type={type} disabled={disabled} expand={expand} mode="ios" className="i-button" onClick={Click}>
        {title}
    </IonButton>
}


export default WrapperIonButton;